export default function getMenu(menus, scope) {
  const _menus = [];

  (menus || []).forEach(({ title, children }) => {
    const _children = children.filter(
      ({ scopeKey }) => scopeKey === 'debug' || scope[scopeKey],
    );
    if (_children.length) {
      _menus.push({
        title,
        children: _children,
      });
    }
  });
  return _menus;
}
